/**
 * 链路追踪 — 生成 W3C 兼容的 32 字符 hex traceId，
 * 通过 X-Trace-ID header 传递给后端。
 */
export function generateTraceId(): string {
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
}
